'use client';

import { Text, Flex, Icon } from '@/_components';
import { FC } from 'react';

export const NoSignatureRequested: FC = () => {
  return (
    <Flex gap={4} isColumn={true}>
      <Icon name="warning" color="secondary" size={20} />
      <Text textAlign="center" type="tiny" color="secondary">
        No signature requested.
      </Text>
    </Flex>
  );
};
